import { useEffect, useRef, useState } from 'react'
import classNames from 'classnames'

import Portal from 'components/ui/Portal/Portal'

import './slider.style.css'

const SLIDER_CONTAIENR_ID = 'slider-container_id'

type Props = {
  isActive?: boolean
  height?: string
  onClose?: () => void
  children: React.ReactNode | React.ReactNode[]
}

export const Slider = ({ isActive, onClose, children, height = '90%' }: Props) => {
  const ref = useRef<HTMLDivElement>(null)
  const [isMounted, setMounted] = useState<boolean>()

  useEffect(() => {
    setMounted(true)
  })

  useEffect(() => {
    const handleWrapperClick = (event: MouseEvent) => {
      const { target } = event

      if (target instanceof Node && ref.current === target) {
        onClose?.()
      }
    }
    const handleEscapePress = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose?.()
      }
    }

    window.addEventListener('click', handleWrapperClick)
    window.addEventListener('keydown', handleEscapePress)

    return () => {
      window.removeEventListener('click', handleWrapperClick)
      window.removeEventListener('keydown', handleEscapePress)
    }
  }, [onClose])

  useEffect(() => {
    if (isActive) {
      document.body.style.overflow = 'hidden'

      return
    }

    document.body.style.overflow = 'unset'
  }, [isActive])

  if (!isMounted) {
    return null
  }

  const classnames = classNames('slider-overlay', {
    'slider-hidden': !isActive,
  })

  return (
    <Portal id={SLIDER_CONTAIENR_ID}>
      <div className={classnames} ref={ref}>
        <div className="slider-content" style={{ height }}>
          {children}
        </div>
      </div>
    </Portal>
  )
}
